import { Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import React from "react";
import type { AccionesTableProps } from "./types";
import { useAccionesTable } from "./useAccionesTable";
import { useIntl } from "react-intl";
import EditIcon from "@mui/icons-material/Edit";
import { useSelector } from "react-redux";
import { useMaterialUIController } from "context";
import ReplayIcon from "@mui/icons-material/Replay";
import FaceRetouchingOffIcon from "@mui/icons-material/FaceRetouchingOff";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import ViewTimelineIcon from "@mui/icons-material/ViewTimeline";

const AccionesTable: React.FC<AccionesTableProps> = (props: AccionesTableProps) => {
  const intl = useIntl();
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const { anchorEl, handleClick, handleClose } = useAccionesTable(props);
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
      {(props?.esListaInventario || props?.esListaProveedores || props?.esListaEmpresas) &&
        props?.row?.estatus === 1 ? (
        <Tooltip title={intl.formatMessage({ id: "general_desactivar" })}>
          <IconButton
            onClick={() => props?.enAccion("desactivar")}
            sx={{ color: darkMode ? "#fff" : "#d10d27" }}
          >
            <VisibilityOffIcon />
          </IconButton>
        </Tooltip>
      ) : null}

      {(props?.esListaInventario || props?.esListaProveedores || props?.esListaEmpresas) &&
        props?.row?.estatus !== 1 ? (
        <Tooltip title={intl.formatMessage({ id: "general_activar" })}>
          <IconButton
            onClick={() => props?.enAccion("activar")}
            sx={{ color: darkMode ? "#fff" : "#1fff26", padding: "0" }}
          >
            <ReplayIcon />
          </IconButton>
        </Tooltip>
      ) : null}

      {props?.esListaRequisicion ||
        props?.esListaInventario ||
        props?.esListaProveedores ||
        props?.esListaCotizaciones ||
        props?.esListaRequisicionEstadisticas ||
        props?.esListaEmpresas ? (
        <Tooltip title={intl.formatMessage({ id: "general_ver_detalles" })}>
          <IconButton
            onClick={() => props?.enAccion("ver")}
            sx={{ color: darkMode ? "#fff" : "#7dc21d", padding: "0" }}
          >
            <VisibilityIcon />
          </IconButton>
        </Tooltip>
      ) : null}

      {props?.esListaInventario ||
        (props?.esListaProveedores && props?.row?.estatus === 1) ||
        (props?.esListaEmpresas && props?.row?.estatus === 1) ? (
        <Tooltip title={intl.formatMessage({ id: "general_editar" })}>
          <IconButton
            onClick={() => props?.enAccion("editar")}
            sx={{ color: darkMode ? "#fff" : "#f5a64c", padding: "0" }}
          >
            <EditIcon />
          </IconButton>
        </Tooltip>
      ) : null}

      {props?.esListaDocumentos ? (
        <Tooltip title={intl.formatMessage({ id: "general_ver_documento" })}>
          <IconButton
            onClick={() => props?.enAccion("ver")}
            sx={{ color: darkMode ? "#fff" : "#7dc21d", padding: "0" }}
          >
            <VisibilityIcon />
          </IconButton>
        </Tooltip>
      ) : null}
      {props?.esListaDocumentos && props?.row?.subido === 1 ? (
        <Tooltip title={intl.formatMessage({ id: "general_editar" })}>
          <IconButton
            onClick={() => props?.enAccion("editar")}
            sx={{ color: darkMode ? "#fff" : "#f5a64c", padding: "0" }}
          >
            <EditIcon />
          </IconButton>
        </Tooltip>
      ) : null}

      {props?.esListaDocumentos && props?.row?.subido === 1 ? (
        <Tooltip title={intl.formatMessage({ id: "general_eliminar" })}>
          <IconButton
            onClick={() => props?.enAccion("eliminar")}
            sx={{ color: darkMode ? "#fff" : "#d10d27", padding: "0" }}
          >
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : null}

      {props?.esListaRequisicion || props?.esListaCotizaciones ? (
        <Tooltip title={intl.formatMessage({ id: "general_ver_bitacora" })}>
          <IconButton
            onClick={() => props?.enAccion("ver_bitacora")}
            sx={{ color: darkMode ? "#fff" : "#4da2e3", padding: "0" }}
          >
            <ViewTimelineIcon />
          </IconButton>
        </Tooltip>
      ) : null}
    </div>
  );
};

export default AccionesTable;
